import React, { useState } from "react";

const TermsAndCondition = () => {
    const [showProductDetails, setShowProductDetails] = useState(false);

    // Function to handle the click on the terms and conditions link
    const handleClick = () => {
      // Show product details when Terms and Conditions are clicked
      setShowProductDetails(true);
  
      // Set a timer to hide the product details after 5 seconds (for example)
      setTimeout(() => {
        setShowProductDetails(false);
      }, 50000); // 5000ms = 5 seconds
    };
  
    return (
      <div>
        {/* Terms and Conditions anchor */}
        <a href="#terms" onClick={handleClick}>
          Terms and Conditions
        </a>
  
        {/* Product Details section */}
        {showProductDetails && (
          <div className="product-details">
            <h2>Terms and Conditions</h2>
            <p>Thank you for shopping with us! By accessing and purchasing products from our online store, you agree to comply with and be bound by the following Terms and Conditions.After order product if you want to cancel order you will get 80% mony back. These terms govern your use of our website, the purchasing process, and the sale of home appliances and electronics gadgets. All product descriptions, prices, and availability are subject to change without notice. We strive to ensure that all information on our site is accurate, but we do not guarantee that all details are complete or free from errors. By placing an order, you confirm that you are legally authorized to make the purchase and that all information provided during the checkout process is accurate. We reserve the right to modify, update, or cancel any orders in accordance with our policies. Please read these terms carefully before making a purchase. If you do not agree with any of these terms, you should refrain from using our website or making a purchase. </p>
            <h2>শর্তাবলী</h2>
            <p>আমাদের সাথে কেনাকাটা করার জন্য আপনাকে ধন্যবাদ! আমাদের অনলাইন স্টোর থেকে পণ্যগুলি অ্যাক্সেস এবং ক্রয় করার মাধ্যমে, আপনি নিম্নলিখিত নিয়ম ও শর্তাবলী মেনে চলতে এবং আবদ্ধ হতে সম্মত হন৷ পণ্য অর্ডার করার পরে আপনি যদি অর্ডার বাতিল করতে চান তবে আপনি ৮০% টাকা ফেরত পাবেন৷ এই শর্তাবলী আপনার আমাদের ওয়েবসাইট ব্যবহার, ক্রয় প্রক্রিয়া এবং গৃহস্থালী যন্ত্রপাতি এবং ইলেকট্রনিক্স গ্যাজেট বিক্রয় নিয়ন্ত্রণ করে। সমস্ত পণ্যের বিবরণ, দাম এবং প্রাপ্যতা বিজ্ঞপ্তি ছাড়াই পরিবর্তন সাপেক্ষে। আমরা নিশ্চিত করার চেষ্টা করি যে আমাদের সাইটে সমস্ত তথ্য সঠিক, তবে আমরা গ্যারান্টি দিই না যে সমস্ত বিবরণ সম্পূর্ণ বা ত্রুটিমুক্ত। একটি অর্ডার দেওয়ার মাধ্যমে, আপনি নিশ্চিত করেন যে আপনি কেনাকাটা করার জন্য আইনত অনুমোদিত এবং চেকআউট প্রক্রিয়া চলাকালীন প্রদত্ত সমস্ত তথ্য সঠিক। আমরা আমাদের নীতিমালা অনুযায়ী যেকোনো অর্ডার সংশোধন, আপডেট বা বাতিল করার অধিকার সংরক্ষণ করি। একটি ক্রয় করার আগে এই শর্তাবলী সাবধানে পড়ুন. আপনি যদি এই শর্তগুলির কোনটির সাথে একমত না হন তবে আপনাকে আমাদের ওয়েবসাইট ব্যবহার করা বা কেনাকাটা করা থেকে বিরত থাকতে হবে।</p>
          </div>
        )}
      </div>
    );
  
};

export default TermsAndCondition;